<template>
  <div>
    <div class="postavitev-besedila">
      <p class="navadno-besedilo">
        Dogodki so razvrščeni po padajočem datumu nastanka (najnovejši pri vrhu).
      </p>
    </div>
    <div class="tabela">
      <span v-if="prikazTabele === '1'">
        <div style="width: 100%; min-height: 100px;" v-loading="nalaganjeTabele">
          <el-table :data="seznamPodatkov" @sort-change="sortAndSplice" stripe :default-sort="{prop: 'formatDatuma', order: 'descending'}">
            <el-table-column prop="formatDatuma" sortable label="Datum"/>
            <el-table-column prop="ip" sortable label="IP"/>
            <el-table-column prop="opis" sortable label="Opis"/>
            <slot name="extra-columns-desktop"/>
            <el-table-column label="Dodatno" sortable prop="additionalTxt">
              <template slot-scope="scope">
                <template v-if="isJsonObject(scope.row.additionalTxt)">
                  <div
                    v-for="(item, index) in getParsedJsonRows(scope.row.additionalTxt, 0)"
                    style="border-bottom: 1px solid lightgrey; display: flex;"
                    :key="`jsonRow-${index}`"
                  >
                    <div :style="`padding-left: ${item.depth * 15}px; font-weight: bold;`">{{item.key}}</div>
                    <div style="flex: auto; text-align: right;">{{item.value}}</div>
                  </div>
                </template>
                <template v-else>{{scope.row.additionalTxt}}</template>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </span>
      <span v-else>
        <div style="width: 100%; min-height: 100px;" v-loading="nalaganjeTabele">
        <el-table :data="seznamPodatkov">
          <el-table-column>
            <template slot-scope="props">
              <p><span><b>Datum: </b></span>{{ props.row.formatDatuma }}</p>
              <p><span><b>IP: </b></span>{{ props.row.ip }}</p>
              <p><span><b>Opis: </b></span>{{ props.row.opis }}</p>
              <slot name="extra-fields-mobile" :row="props.row"/>
              <p>
                <span><b>Dodatno: </b></span>
                <template v-if="isJsonObject(props.row.additionalTxt)">
                  <div
                    v-for="(item, index) in getParsedJsonRows(props.row.additionalTxt, 0)"
                    style="border-bottom: 1px solid lightgrey; display: flex;"
                    :key="`jsonRow-${index}`"
                  >
                    <div :style="`padding-left: ${item.depth * 15}px;`">{{item.key}}</div>
                    <div style="flex: auto; text-align: right;">{{item.value}}</div>
                  </div>
                </template>
                <template v-else>{{props.row.additionalTxt}}</template>
              </p>
            </template>
          </el-table-column>
        </el-table>
        </div>
      </span>
      <div class="text-center" style="cursor: pointer; padding-top: 20px">
        <el-pagination
          :hide-on-single-page="true"
          @current-change="prikaziStran"
          :page-size="1"
          layout="prev, pager, next"
          :total="dolzinaSeznama"
          small>
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import {PrikazVsebine} from 'src/assets/js/globalne_funkcije/SplosneGlobalneFunkcije/SirinaOkna.js'
import {JsonHelper} from '../../../../../assets/js/globalne_funkcije/SplosneGlobalneFunkcije/JsonHelper'
import {
  Table, TableColumn, Loading, Pagination
} from 'element-ui'
import Vue from 'vue'
Vue.use(Pagination)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Loading)
export default {
  name: 'DnevnikTabela',
  mixins: [PrikazVsebine, JsonHelper],
  components: {
    [Pagination.name]: Pagination
  },
  props: {
    podatki: {
      type: Array,
      default: () => []
    },
    nalaganjeTabele: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      uporabnikoviPodatki: [],
      seznamPodatkov: [],
      dolzinaSeznama: null
    }
  },
  watch: {
    podatki (val) {
      this.uporabnikoviPodatki = [...val]
      this.sortAndSplice(null)
    }
  },
  methods: {
    prikaziStran (stran) {
      const chunk = 8
      const tmpData = []
      for (let i = 0; i < this.uporabnikoviPodatki.length; i += chunk) {
        tmpData.push(this.uporabnikoviPodatki.slice(i, i + chunk))
      }
      this.dolzinaSeznama = tmpData.length
      this.seznamPodatkov = tmpData[stran - 1] === undefined ? [] : tmpData[stran - 1]
    },
    sortAndSplice (sortParams = null) {
      const byDate = sortParams === null || sortParams.prop === 'formatDatuma'
      if (byDate) {
        const desc = sortParams === null || sortParams.order === 'descending'
        this.uporabnikoviPodatki.sort(function (a, b) {
          return desc
            ? new Date(b.datum.date) - new Date(a.datum.date)
            : new Date(a.datum.date) - new Date(b.datum.date)
        })
      } else {
        const prop = sortParams.prop
        const asc = sortParams.order === 'ascending'
        this.uporabnikoviPodatki.sort(function (a, b) {
          const valA = (a[prop] || '').toLowerCase()
          const valB = (b[prop] || '').toLowerCase()
          if (valA < valB) return asc ? -1 : 1
          if (valA > valB) return asc ? 1 : -1
          return 0
        })
      }
      this.prikaziStran(1)
    }
  }
}
</script>
<style scoped src="../../../../../../static/css/moj_profil/varnost.css">
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Mojprofil/Varnost/DnevnikTabela.vue